import { observable } from 'mobx';
import { useEffect, useRef } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import { getParameterByName, jumpPage } from '@src/utils/common-util.js';

class DownloadStore extends BaseStore {
  @observable isActive = false;

  @observable
  layerData = {
    download: {
      launcher_download_link:
        'https://ssglauncher.xoyocdn.com/ssglauncher/ssg/Client/prod/Channel/MechaBREAKCN/SeasunGameInstaller-MechaBREAKCN-mechabreak_cn.exe',
      store_page_download_link: ''
    }
  };

  @observable isShowBackTop = false;

  installerQuestion = [
    {
      title: '关于显卡驱动版本过低问题的解决方案',
      link: 'https://mechabreak.seasungames.cn/show-7422-306-1.html'
    },
    {
      title: '关于英特尔CPU问题的解决方案',
      link: 'https://mechabreak.seasungames.cn/show-7422-269-1.html'
    },
    {
      title: '《解限机游戏禁止/不建议使用的软硬件列表》',
      link: 'https://mechabreak.seasungames.cn/show-7422-339-1.html'
    }
  ];

  graphicsCardInstallerPackage = [
    {
      title: 'NVIDIA',
      icon: require('./images/NVIDIA.png'),
      link: 'https://www.nvidia.cn/drivers/lookup/'
    },
    {
      title: 'AMD',
      icon: require('./images/AMD.png'),
      link: 'https://www.amd.com/zh-cn/support/download/drivers.html'
    },
    {
      title: 'INTEL',
      icon: require('./images/INTEL.png'),
      link: 'https://www.intel.cn/content/www/cn/zh/download-center/home.html?lang=zho&iid=gg_support-cn+home_download'
    }
  ];

  /**
   * 返回官网首页/FAB/分流页，根据from参数判断
   * @returns {void}
   */
  back = () => {
    // let from = getParameterByName('from');
    // if (from) {
    //   window.location.href = from;
    // } else if (IS_DEV_ENV) {
    //   window.location.href = window.location.origin + window.location.pathname;
    // } else {
    //   jumpPage('index.html');
    // }

    if (IS_DEV_ENV) {
      window.location.href = window.location.origin + window.location.pathname;
    } else {
      window.history.back();
    }
  };

  onBackTop = () => {
    this.scrollBox.current.scrollTop = 0;
  };

  use() {
    super.use();
    const funlinkData = useFunLinkPageData();
    this.scrollBox = useRef(null);
    this.$globalStore.showNavbarDownloadBtn = false;

    useEffect(
      () => {
        if (funlinkData) {
          this.layerData = funlinkData;
        }
      },
      [funlinkData]
    );
    useMount(() => {
      this.isActive = true;

      this.scrollBox.current?.addEventListener('scroll', e => {
        this.isShowBackTop = e.target.scrollTop > 100;
      });
    });
  }
}

export default DownloadStore;
